import * as React from 'react';
import { TeamMemberIdContextProvider } from '../../../../../../sanity';
import { ErrorBoundary } from '../../../../../ErrorBoundary';
import {
  TeamMemberContainer,
  TeamMemberContent,
} from './components';

export const TeamMember = (props: {
  id: string,
}) => {
  const {
    id,
  } = props;
  return (
    <ErrorBoundary renderNull>
      <TeamMemberIdContextProvider id={id}>
        <TeamMemberContainer>
          <TeamMemberContent />
        </TeamMemberContainer>
      </TeamMemberIdContextProvider>
    </ErrorBoundary>
  );
};
